// Bilingual (EN/PT) translations for the School module
export const translations = {
  en: {
    'app.school': 'Escola Libanesa Internacional',
    'app.shortName': 'E.L.I',
    'app.tagline': 'School Management',
    // groups / nav
    'nav.school': 'School',
    'nav.finance': 'Finance',
    'nav.portal': 'My Portal',
    'nav.administration': 'Administration',
    'nav.settings': 'Settings',
    'nav.dashboard': 'Dashboard',
    'nav.families': 'Family/Guardian',
    'nav.students': 'Students',
    'nav.teachers': 'Teacher/Staff',
    'nav.classes': 'Classes & Sections',
    'nav.subjects': 'Subjects',
    'nav.enrollment': 'Enrollment',
    'nav.academicYears': 'Academic Years',
    'nav.exams': 'Exams',
    'nav.marks': 'Marks Entry',
    'nav.attendance': 'Attendance',
    'att.title': 'Attendance',
    'att.takeSubtitle': 'Record daily student attendance',
    'att.date': 'Date',
    'att.present': 'Present',
    'att.absent': 'Absent',
    'att.late': 'Late',
    'att.excused': 'Excused',
    'att.notMarked': 'Not marked',
    'att.markAllPresent': 'Mark all present',
    'att.rate': 'Attendance Rate',
    'att.alreadyTaken': 'Attendance already recorded for this date. You can update it below.',
    'att.selectFilters': 'Select a class, section and date',
    'att.selectFiltersDesc': 'Choose the filters above to take attendance',
    'att.myTitle': 'My Attendance',
    'att.saved': 'Attendance saved',
    'att.noStudents': 'No students in this section',
    'att.summary': 'Summary',
    'nav.gradingScales': 'Grading Scale',
    'nav.reportCards': 'Report Cards',
    'nav.timetable': 'Timetable',
    'nav.myProfile': 'My Profile',
    'nav.myChildren': 'My Children',
    'nav.myClasses': 'My Classes',
    'nav.signOut': 'Sign Out',
    // common
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.save': 'Save',
    'common.saving': 'Saving...',
    'common.auto': 'Automatic (based on average)',
    'subjects.bulletinSettings': 'Bulletin Structure',
    'subjects.bulletinHint': 'Used to group and grade this discipline on report cards (UV / Curricular Component).',
    'subjects.uvGroup': 'Value Unit / Component',
    'subjects.uvOrder': 'Group order',
    'subjects.maxNote': 'Max note',
    'subjects.coefficient': 'Coefficient',
    'common.cancel': 'Cancel',
    'common.search': 'Search',
    'common.actions': 'Actions',
    'common.loading': 'Loading...',
    'common.noData': 'Nothing here yet',
    'common.confirm': 'Confirm',
    'common.close': 'Close',
    'common.view': 'View',
    'common.all': 'All',
    'common.status': 'Status',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.name': 'Name',
    'common.email': 'Email',
    'common.phone': 'Phone',
    'common.gender': 'Gender',
    'common.male': 'Male',
    'common.female': 'Female',
    'common.required': 'Required',
    'common.deleted': 'Deleted successfully',
    'common.saved': 'Saved successfully',
    'common.print': 'Print',
    'common.total': 'Total',
    // dashboard
    'dash.welcome': 'Welcome back',
    'dash.overview': "Here is what's happening at your school",
    'dash.students': 'Students',
    'dash.teachers': 'Teachers',
    'dash.classes': 'Classes',
    'dash.subjects': 'Subjects',
    'dash.sections': 'Sections',
    'dash.exams': 'Exams',
    'dash.genderSplit': 'Gender Distribution',
    'dash.classDistribution': 'Students per Class',
    'dash.recentAdmissions': 'Recent Admissions',
    'dash.noStudents': 'No students yet. Add your first admission to get started.',
    // students
    'students.title': 'Students',
    'students.subtitle': 'Manage admissions and student records',
    'students.new': 'New Admission',
    'students.admissionNo': 'Admission No',
    'students.rollNo': 'Roll No',
    'students.class': 'Class',
    'students.section': 'Section',
    'students.guardian': 'Guardian',
    'students.dob': 'Date of Birth',
    'students.bloodGroup': 'Blood Group',
    'students.address': 'Address',
    'students.admissionDate': 'Admission Date',
    'students.parentInfo': 'Guardian / Parent',
    'students.parentName': 'Guardian Name',
    'students.createParent': 'Create new guardian',
    'students.selectParent': 'Select existing guardian',
    'students.profile': 'Student Profile',
    // teachers
    'teachers.title': 'Teachers',
    'teachers.subtitle': 'Manage teaching staff',
    'teachers.new': 'Add Teacher',
    'teachers.employeeId': 'Employee ID',
    'teachers.qualification': 'Qualification',
    'teachers.subjects': 'Subjects',
    'teachers.joiningDate': 'Joining Date',
    // classes
    'classes.title': 'Classes & Sections',
    'classes.subtitle': 'Organize grade levels and sections',
    'classes.newClass': 'Add Class',
    'classes.newSection': 'Add Section',
    'classes.level': 'Level',
    'classes.sections': 'Sections',
    'classes.capacity': 'Capacity',
    'classes.classTeacher': 'Class Teacher',
    // subjects
    'subjects.title': 'Subjects',
    'subjects.subtitle': 'Define subjects and assign teachers',
    'subjects.new': 'Add Subject',
    'subjects.code': 'Code',
    'subjects.fullMarks': 'Full Marks',
    'subjects.passMarks': 'Pass Marks',
    'subjects.teacher': 'Teacher',
    'subjects.type': 'Type',
    // academic years
    'years.title': 'Academic Years',
    'years.subtitle': 'Manage sessions and terms',
    'years.new': 'Add Academic Year',
    'years.startDate': 'Start Date',
    'years.endDate': 'End Date',
    'years.terms': 'Terms',
    'years.addTerm': 'Add Term',
    'exams.subtitle': 'Create one exam per trimester — bulletins are built per trimester',
    'exams.createTrimesters': 'Create Trimester Exams',
    'exams.noTerm': 'No trimester — not on bulletins',
    'exams.bulletinReady': 'Bulletin-ready',
    'exams.termRequired': 'Trimester is required for bulletins',
    'exams.yearRequired': 'Academic year is required',
    'exams.dialogHint': 'Each trimester = one exam. Bulletins are generated per trimester.',
    'exams.createTermsBtn': 'Create Trimestre 1/2/3',
    'exams.noTermsYet': 'No trimesters defined for this year.',
    'exams.bulkHint': 'Creates one exam per trimester (1/2/3) for the selected year, linked to the selected classes. Missing trimesters are created automatically.',
    // enrollment
    'enroll.title': 'Enrollment',
    'enroll.subtitle': 'Assign students to classes and sections',
    'enroll.assign': 'Assign Student',
    // report card
    'rc.title': 'Report Card',
    'rc.subject': 'Subject',
    'rc.marks': 'Marks',
    'rc.grade': 'Grade',
    'rc.percent': 'Percent',
    'rc.remark': 'Remark',
    'rc.total': 'Total',
    'rc.percentage': 'Percentage',
    'rc.overallGrade': 'Overall Grade',
    'rc.rank': 'Rank',
    'rc.result': 'Result',
    'rc.pass': 'PASS',
    'rc.fail': 'FAIL',
    'rc.gpa': 'GPA',
    'rc.classTeacher': 'Class Teacher',
    'rc.principal': 'Principal',
    'rc.selectFilters': 'Select an exam, class & section to generate bulletins',
    'rc.noMarks': 'No marks recorded for this selection',
    'rc.moyenne': 'Average /20',
    'rc.mention': 'Mention',
    'rc.decision': 'Decision',
    'rc.observations': 'Observations & Decision',
    'rc.teacherObs': 'Class Teacher Observation',
    'rc.directionObs': 'Direction',
    'rc.councilObs': 'Pedagogical Council',
    'rc.saveRemarks': 'Save Observations',
    'rc.bulletinFormat': 'Bulletin Format',
    'rc.generate': 'Generate',
    'rc.scopeTerm': 'Single Trimester',
    'rc.scopeGeneral': 'General (All Terms)',
    'rc.allSections': 'All sections',
    'rc.generalHint': 'Aggregates all trimesters of the academic year into one cumulative General report.',
    'rc.aiAnalysis': 'AI Analysis',
    'rc.aiGenerate': 'Generate Analysis',
    'rc.aiRegenerate': 'Regenerate',
    'rc.aiGenerating': 'Analyzing the class… this can take up to a minute.',
    'rc.aiNone': 'No analysis yet. Generate one below.',
    'rc.aiHint': 'AI-powered analysis of the whole class grade report.',
    'rc.aiCharts': 'Visual Insights',
    'rc.aiSummary': 'Detailed Analysis',
    'rc.exportPdf': 'Export PDF',
    'rc.pdfExporting': 'Exporting…',
    'rc.pdfDone': 'PDF exported',
    'rc.pdfFailed': 'Failed to export PDF',
    'rc.aiDone': 'Analysis ready',
    'rc.aiFailed': 'AI analysis failed',
    'common.close': 'Close',
    // portals
    'portal.studentTitle': 'My Academics',
    'portal.parentTitle': 'My Children',
    'portal.teacherTitle': 'My Classes',
    'portal.selectExam': 'Select Exam',
    'portal.viewReport': 'View Report Card',
    'portal.noProfile': 'No profile is linked to your account yet. Please contact the administration.',
    'portal.lessons': 'Lessons',
    'portal.lessonsEmpty': 'No lessons have been shared with your class yet.',
    'portal.openLesson': 'Open Lesson',
    'portal.myTimetable': 'My Timetable',
    'portal.noTimetable': 'No timetable yet',
    'portal.noTimetableHint': 'Your schedule for this academic year has not been published yet.',
    'role.super_admin': 'Super Admin',
    'role.admin': 'Admin',
    'role.administration': 'Administration',
    'role.direction': 'Direction',
    'role.coordinator': 'Coordinator',
    'role.accountant': 'Accountant',
    'role.receptionist': 'Receptionist',
    'role.librarian': 'Librarian',
    'role.driver': 'Driver',
    'role.service': 'Service',
    'role.teacher': 'Teacher',
    'role.student': 'Student',
    'role.parent': 'Parent',
    'role.viewer': 'Viewer',
    'role.cashier': 'Cashier',
    'people.loginAccount': 'Login Account',
    'people.role': 'Role',
    'people.password': 'Password',
    'people.loginRequired': 'A login (email, password and role) is required.',
  },
  pt: {
    'app.school': 'Escola Libanesa Internacional',
    'app.shortName': 'E.L.I',
    'app.tagline': 'Gestão Escolar',
    'nav.school': 'Escola',
    'nav.finance': 'Financeiro',
    'nav.portal': 'Meu Portal',
    'nav.administration': 'Administra\u00e7\u00e3o',
    'nav.settings': 'Configura\u00e7\u00f5es',
    'nav.dashboard': 'Painel',
    'nav.families': 'Família/Responsável',
    'nav.students': 'Alunos',
    'nav.teachers': 'Professor/Funcionário',
    'nav.classes': 'Turmas e Seções',
    'nav.subjects': 'Disciplinas',
    'nav.enrollment': 'Matrícula',
    'nav.academicYears': 'Anos Letivos',
    'nav.exams': 'Provas',
    'nav.marks': 'Lançar Notas',
    'nav.attendance': 'Frequência',
    'att.title': 'Frequência',
    'att.takeSubtitle': 'Registrar a frequência diária dos alunos',
    'att.date': 'Data',
    'att.present': 'Presente',
    'att.absent': 'Ausente',
    'att.late': 'Atrasado',
    'att.excused': 'Justificado',
    'att.notMarked': 'Não marcado',
    'att.markAllPresent': 'Marcar todos presentes',
    'att.rate': 'Taxa de Frequência',
    'att.alreadyTaken': 'Frequência já registrada para esta data. Você pode atualizá-la abaixo.',
    'att.selectFilters': 'Selecione turma, seção e data',
    'att.selectFiltersDesc': 'Escolha os filtros acima para registrar a frequência',
    'att.myTitle': 'Minha Frequência',
    'att.saved': 'Frequência salva',
    'att.noStudents': 'Nenhum aluno nesta seção',
    'att.summary': 'Resumo',
    'nav.gradingScales': 'Escala de Notas',
    'nav.reportCards': 'Boletins',
    'nav.timetable': 'Horário',
    'nav.myProfile': 'Meu Perfil',
    'nav.myChildren': 'Meus Filhos',
    'nav.myClasses': 'Minhas Turmas',
    'nav.signOut': 'Sair',
    'common.add': 'Adicionar',
    'common.edit': 'Editar',
    'common.delete': 'Excluir',
    'common.save': 'Salvar',
    'common.saving': 'Salvando...',
    'common.auto': 'Automático (com base na média)',
    'subjects.bulletinSettings': 'Estrutura do Boletim',
    'subjects.bulletinHint': 'Usado para agrupar e avaliar esta disciplina no boletim (Componente Curricular).',
    'subjects.uvGroup': 'Unidade / Componente Curricular',
    'subjects.uvOrder': 'Ordem do grupo',
    'subjects.maxNote': 'Nota máxima',
    'subjects.coefficient': 'Coeficiente',
    'common.cancel': 'Cancelar',
    'common.search': 'Buscar',
    'common.actions': 'Ações',
    'common.loading': 'Carregando...',
    'common.noData': 'Nada por aqui ainda',
    'common.confirm': 'Confirmar',
    'common.close': 'Fechar',
    'common.view': 'Ver',
    'common.all': 'Todos',
    'common.status': 'Situação',
    'common.active': 'Ativo',
    'common.inactive': 'Inativo',
    'common.name': 'Nome',
    'common.email': 'E-mail',
    'common.phone': 'Telefone',
    'common.gender': 'Sexo',
    'common.male': 'Masculino',
    'common.female': 'Feminino',
    'common.required': 'Obrigatório',
    'common.deleted': 'Excluído com sucesso',
    'common.saved': 'Salvo com sucesso',
    'common.print': 'Imprimir',
    'common.total': 'Total',
    'dash.welcome': 'Bem-vindo de volta',
    'dash.overview': 'Veja o que está acontecendo na sua escola',
    'dash.students': 'Alunos',
    'dash.teachers': 'Professores',
    'dash.classes': 'Turmas',
    'dash.subjects': 'Disciplinas',
    'dash.sections': 'Seções',
    'dash.exams': 'Provas',
    'dash.genderSplit': 'Distribuição por Sexo',
    'dash.classDistribution': 'Alunos por Turma',
    'dash.recentAdmissions': 'Matrículas Recentes',
    'dash.noStudents': 'Nenhum aluno ainda. Adicione a primeira matrícula para começar.',
    'students.title': 'Alunos',
    'students.subtitle': 'Gerencie matrículas e cadastros de alunos',
    'students.new': 'Nova Matrícula',
    'students.admissionNo': 'Nº Matrícula',
    'students.rollNo': 'Nº Chamada',
    'students.class': 'Turma',
    'students.section': 'Seção',
    'students.guardian': 'Responsável',
    'students.dob': 'Data de Nascimento',
    'students.bloodGroup': 'Tipo Sanguíneo',
    'students.address': 'Endereço',
    'students.admissionDate': 'Data da Matrícula',
    'students.parentInfo': 'Responsável / Pais',
    'students.parentName': 'Nome do Responsável',
    'students.createParent': 'Criar novo responsável',
    'students.selectParent': 'Selecionar responsável existente',
    'students.profile': 'Perfil do Aluno',
    'teachers.title': 'Professores',
    'teachers.subtitle': 'Gerencie o corpo docente',
    'teachers.new': 'Adicionar Professor',
    'teachers.employeeId': 'Matrícula Funcional',
    'teachers.qualification': 'Formação',
    'teachers.subjects': 'Disciplinas',
    'teachers.joiningDate': 'Data de Admissão',
    'classes.title': 'Turmas e Seções',
    'classes.subtitle': 'Organize séries e seções',
    'classes.newClass': 'Adicionar Turma',
    'classes.newSection': 'Adicionar Seção',
    'classes.level': 'Nível',
    'classes.sections': 'Seções',
    'classes.capacity': 'Capacidade',
    'classes.classTeacher': 'Professor Responsável',
    'subjects.title': 'Disciplinas',
    'subjects.subtitle': 'Defina disciplinas e atribua professores',
    'subjects.new': 'Adicionar Disciplina',
    'subjects.code': 'Código',
    'subjects.fullMarks': 'Nota Máxima',
    'subjects.passMarks': 'Nota de Aprovação',
    'subjects.teacher': 'Professor',
    'subjects.type': 'Tipo',
    'years.title': 'Anos Letivos',
    'years.subtitle': 'Gerencie períodos e bimestres',
    'years.new': 'Adicionar Ano Letivo',
    'years.startDate': 'Data Início',
    'years.endDate': 'Data Fim',
    'years.terms': 'Bimestres',
    'years.addTerm': 'Adicionar Bimestre',
    'exams.subtitle': 'Crie um exame por trimestre — os boletins são gerados por trimestre',
    'exams.createTrimesters': 'Criar Exames por Trimestre',
    'exams.noTerm': 'Sem trimestre — não aparece nos boletins',
    'exams.bulletinReady': 'Pronto para boletim',
    'exams.termRequired': 'O trimestre é obrigatório para os boletins',
    'exams.yearRequired': 'O ano letivo é obrigatório',
    'exams.dialogHint': 'Cada trimestre = um exame. Os boletins são gerados por trimestre.',
    'exams.createTermsBtn': 'Criar Trimestre 1/2/3',
    'exams.noTermsYet': 'Nenhum trimestre definido para este ano.',
    'exams.bulkHint': 'Cria um exame por trimestre (1/2/3) do ano selecionado, vinculado às turmas selecionadas. Trimestres ausentes são criados automaticamente.',
    'enroll.title': 'Matrícula',
    'enroll.subtitle': 'Atribua alunos a turmas e seções',
    'enroll.assign': 'Matricular Aluno',
    'rc.title': 'Boletim',
    'rc.subject': 'Disciplina',
    'rc.marks': 'Notas',
    'rc.grade': 'Conceito',
    'rc.percent': 'Percentual',
    'rc.remark': 'Observação',
    'rc.total': 'Total',
    'rc.percentage': 'Percentual',
    'rc.overallGrade': 'Conceito Geral',
    'rc.rank': 'Classificação',
    'rc.result': 'Resultado',
    'rc.pass': 'APROVADO',
    'rc.fail': 'REPROVADO',
    'rc.gpa': 'Média',
    'rc.classTeacher': 'Professor Responsável',
    'rc.principal': 'Diretor(a)',
    'rc.selectFilters': 'Selecione exame, turma e seção para gerar boletins',
    'rc.noMarks': 'Nenhuma nota registrada para esta seleção',
    'rc.moyenne': 'Média /20',
    'rc.mention': 'Menção',
    'rc.decision': 'Decisão',
    'rc.observations': 'Observações e Decisão',
    'rc.teacherObs': 'Observação do Professor Titular',
    'rc.directionObs': 'Direção',
    'rc.councilObs': 'Conselho Pedagógico',
    'rc.saveRemarks': 'Salvar Observações',
    'rc.bulletinFormat': 'Formato do Boletim',
    'rc.generate': 'Gerar',
    'rc.scopeTerm': 'Trimestre único',
    'rc.scopeGeneral': 'Geral (Todos os trimestres)',
    'rc.allSections': 'Todas as seções',
    'rc.generalHint': 'Agrega todos os trimestres do ano letivo em um boletim geral cumulativo.',
    'rc.aiAnalysis': 'Análise IA',
    'rc.aiGenerate': 'Gerar Análise',
    'rc.aiRegenerate': 'Regenerar',
    'rc.aiGenerating': 'Analisando a turma… pode levar até um minuto.',
    'rc.aiNone': 'Nenhuma análise ainda. Gere uma abaixo.',
    'rc.aiHint': 'Análise por IA de todo o boletim da turma.',
    'rc.aiCharts': 'Análises Visuais',
    'rc.aiSummary': 'Análise Detalhada',
    'rc.exportPdf': 'Exportar PDF',
    'rc.pdfExporting': 'Exportando…',
    'rc.pdfDone': 'PDF exportado',
    'rc.pdfFailed': 'Falha ao exportar PDF',
    'rc.aiDone': 'Análise pronta',
    'rc.aiFailed': 'Falha na análise por IA',
    'common.close': 'Fechar',
    'portal.studentTitle': 'Minha Vida Acadêmica',
    'portal.parentTitle': 'Meus Filhos',
    'portal.teacherTitle': 'Minhas Turmas',
    'portal.selectExam': 'Selecionar Prova',
    'portal.viewReport': 'Ver Boletim',
    'portal.noProfile': 'Nenhum perfil está vinculado à sua conta. Entre em contato com a administração.',
    'portal.lessons': 'Aulas',
    'portal.lessonsEmpty': 'Nenhuma aula foi compartilhada com a sua turma ainda.',
    'portal.openLesson': 'Abrir Aula',
    'portal.myTimetable': 'Meu Horário',
    'portal.noTimetable': 'Nenhum horário ainda',
    'portal.noTimetableHint': 'O seu horário para este ano letivo ainda não foi publicado.',
    'role.super_admin': 'Super Admin',
    'role.admin': 'Admin',
    'role.administration': 'Administração',
    'role.direction': 'Direção',
    'role.coordinator': 'Coordenador',
    'role.accountant': 'Contador',
    'role.receptionist': 'Recepcionista',
    'role.librarian': 'Bibliotecário',
    'role.driver': 'Motorista',
    'role.service': 'Serviço',
    'role.teacher': 'Professor',
    'role.student': 'Aluno',
    'role.parent': 'Responsável',
    'role.viewer': 'Visualizador',
    'role.cashier': 'Caixa',
    'people.loginAccount': 'Conta de Acesso',
    'people.role': 'Função',
    'people.password': 'Senha',
    'people.loginRequired': 'É obrigatório um acesso (e-mail, senha e função).',
  },
  fr: {
    'app.school': 'Escola Libanesa Internacional',
    'app.shortName': 'E.L.I',
    'app.tagline': 'Gestion Scolaire',
    'nav.school': 'École',
    'nav.finance': 'Finances',
    'nav.portal': 'Mon Portail',
    'nav.administration': 'Administration',
    'nav.settings': 'Paramètres',
    'nav.dashboard': 'Tableau de bord',
    'nav.families': 'Famille/Tuteur',
    'nav.students': 'Élèves',
    'nav.teachers': 'Enseignants',
    'nav.classes': 'Classes et Sections',
    'nav.subjects': 'Matières',
    'nav.enrollment': 'Inscription',
    'nav.academicYears': 'Années scolaires',
    'nav.exams': 'Examens',
    'nav.marks': 'Saisie des notes',
    'nav.attendance': 'Présences',
    'att.title': 'Présences',
    'att.takeSubtitle': 'Enregistrez la présence quotidienne des élèves',
    'att.date': 'Date',
    'att.present': 'Présent',
    'att.absent': 'Absent',
    'att.late': 'En retard',
    'att.excused': 'Excusé',
    'att.notMarked': 'Non marqué',
    'att.markAllPresent': 'Marquer tous présents',
    'att.rate': 'Taux de présence',
    'att.alreadyTaken': 'La présence a déjà été enregistrée pour cette date. Vous pouvez la modifier ci-dessous.',
    'att.selectFilters': 'Sélectionnez une classe, une section et une date',
    'att.selectFiltersDesc': 'Choisissez les filtres ci-dessus pour faire l\u2019appel',
    'att.myTitle': 'Mes présences',
    'att.saved': 'Présence enregistrée',
    'att.noStudents': 'Aucun élève dans cette section',
    'att.summary': 'Résumé',
    'nav.gradingScales': 'Barème de notation',
    'nav.reportCards': 'Bulletins',
    'nav.timetable': 'Emploi du temps',
    'nav.myProfile': 'Mon profil',
    'nav.myChildren': 'Mes enfants',
    'nav.myClasses': 'Mes classes',
    'nav.signOut': 'Se déconnecter',
    'common.add': 'Ajouter',
    'common.edit': 'Modifier',
    'common.delete': 'Supprimer',
    'common.save': 'Enregistrer',
    'common.saving': 'Enregistrement...',
    'common.auto': 'Automatique (selon la moyenne)',
    'subjects.bulletinSettings': 'Structure du bulletin',
    'subjects.bulletinHint': 'Sert à regrouper et noter cette discipline sur le bulletin (Unité de Valeur).',
    'subjects.uvGroup': 'Unité de Valeur / Composante',
    'subjects.uvOrder': 'Ordre du groupe',
    'subjects.maxNote': 'Note maximale',
    'subjects.coefficient': 'Coefficient',
    'common.cancel': 'Annuler',
    'common.search': 'Rechercher',
    'common.actions': 'Actions',
    'common.loading': 'Chargement...',
    'common.noData': 'Rien pour le moment',
    'common.confirm': 'Confirmer',
    'common.close': 'Fermer',
    'common.view': 'Voir',
    'common.all': 'Tous',
    'common.status': 'Statut',
    'common.active': 'Actif',
    'common.inactive': 'Inactif',
    'common.name': 'Nom',
    'common.email': 'E-mail',
    'common.phone': 'Téléphone',
    'common.gender': 'Sexe',
    'common.male': 'Masculin',
    'common.female': 'Féminin',
    'common.required': 'Obligatoire',
    'common.deleted': 'Supprimé avec succès',
    'common.saved': 'Enregistré avec succès',
    'common.print': 'Imprimer',
    'common.total': 'Total',
    'dash.welcome': 'Bon retour',
    'dash.overview': 'Voici ce qui se passe dans votre établissement',
    'dash.students': 'Élèves',
    'dash.teachers': 'Enseignants',
    'dash.classes': 'Classes',
    'dash.subjects': 'Matières',
    'dash.sections': 'Sections',
    'dash.exams': 'Examens',
    'dash.genderSplit': 'Répartition par sexe',
    'dash.classDistribution': 'Élèves par classe',
    'dash.recentAdmissions': 'Inscriptions récentes',
    'dash.noStudents': 'Aucun élève pour le moment. Ajoutez votre première inscription pour commencer.',
    'students.title': 'Élèves',
    'students.subtitle': 'Gérez les inscriptions et les dossiers des élèves',
    'students.new': 'Nouvelle inscription',
    'students.admissionNo': 'N\u00b0 d\u2019inscription',
    'students.rollNo': 'N\u00b0 d\u2019appel',
    'students.class': 'Classe',
    'students.section': 'Section',
    'students.guardian': 'Responsable',
    'students.dob': 'Date de naissance',
    'students.bloodGroup': 'Groupe sanguin',
    'students.address': 'Adresse',
    'students.admissionDate': 'Date d\u2019inscription',
    'students.parentInfo': 'Responsable / Parent',
    'students.parentName': 'Nom du responsable',
    'students.createParent': 'Créer un nouveau responsable',
    'students.selectParent': 'Sélectionner un responsable existant',
    'students.profile': 'Profil de l\u2019élève',
    'teachers.title': 'Enseignants',
    'teachers.subtitle': 'Gérez le personnel enseignant',
    'teachers.new': 'Ajouter un enseignant',
    'teachers.employeeId': 'Matricule',
    'teachers.qualification': 'Qualification',
    'teachers.subjects': 'Matières',
    'teachers.joiningDate': 'Date d\u2019embauche',
    'classes.title': 'Classes et Sections',
    'classes.subtitle': 'Organisez les niveaux et les sections',
    'classes.newClass': 'Ajouter une classe',
    'classes.newSection': 'Ajouter une section',
    'classes.level': 'Niveau',
    'classes.sections': 'Sections',
    'classes.capacity': 'Capacité',
    'classes.classTeacher': 'Professeur principal',
    'subjects.title': 'Matières',
    'subjects.subtitle': 'Définissez les matières et attribuez les enseignants',
    'subjects.new': 'Ajouter une matière',
    'subjects.code': 'Code',
    'subjects.fullMarks': 'Note maximale',
    'subjects.passMarks': 'Note de passage',
    'subjects.teacher': 'Enseignant',
    'subjects.type': 'Type',
    'years.title': 'Années scolaires',
    'years.subtitle': 'Gérez les sessions et les trimestres',
    'years.new': 'Ajouter une année scolaire',
    'years.startDate': 'Date de début',
    'years.endDate': 'Date de fin',
    'years.terms': 'Trimestres',
    'years.addTerm': 'Ajouter un trimestre',
    'exams.subtitle': 'Créez un examen par trimestre — les bulletins sont générés par trimestre',
    'exams.createTrimesters': 'Créer les examens trimestriels',
    'exams.noTerm': 'Aucun trimestre — absent des bulletins',
    'exams.bulletinReady': 'Prêt pour bulletin',
    'exams.termRequired': 'Le trimestre est obligatoire pour les bulletins',
    'exams.yearRequired': 'L\u2019année scolaire est obligatoire',
    'exams.dialogHint': 'Chaque trimestre = un examen. Les bulletins sont générés par trimestre.',
    'exams.createTermsBtn': 'Créer Trimestre 1/2/3',
    'exams.noTermsYet': 'Aucun trimestre défini pour cette année.',
    'exams.bulkHint': 'Crée un examen par trimestre (1/2/3) de l\u2019année sélectionnée, lié aux classes sélectionnées. Les trimestres manquants sont créés automatiquement.',
    'enroll.title': 'Inscription',
    'enroll.subtitle': 'Affectez les élèves aux classes et sections',
    'enroll.assign': 'Affecter un élève',
    'rc.title': 'Bulletin',
    'rc.subject': 'Matière',
    'rc.marks': 'Notes',
    'rc.grade': 'Mention',
    'rc.percent': 'Pourcentage',
    'rc.remark': 'Remarque',
    'rc.total': 'Total',
    'rc.percentage': 'Pourcentage',
    'rc.overallGrade': 'Mention générale',
    'rc.rank': 'Rang',
    'rc.result': 'Résultat',
    'rc.pass': 'ADMIS',
    'rc.fail': 'NON ADMIS',
    'rc.gpa': 'Moyenne',
    'rc.classTeacher': 'Professeur principal',
    'rc.principal': 'Directeur',
    'rc.selectFilters': 'Sélectionnez un examen, une classe et une section pour générer les bulletins',
    'rc.noMarks': 'Aucune note enregistrée pour cette sélection',
    'rc.moyenne': 'Moyenne /20',
    'rc.mention': 'Mention',
    'rc.decision': 'Décision',
    'rc.observations': 'Observations et Décision',
    'rc.teacherObs': 'Observation du professeur titulaire',
    'rc.directionObs': 'Direction',
    'rc.councilObs': 'Conseil pédagogique',
    'rc.saveRemarks': 'Enregistrer les observations',
    'rc.bulletinFormat': 'Format du bulletin',
    'rc.generate': 'Générer',
    'rc.scopeTerm': 'Trimestre unique',
    'rc.scopeGeneral': 'Général (Tous les trimestres)',
    'rc.allSections': 'Toutes les sections',
    'rc.generalHint': 'Regroupe tous les trimestres de l\u2019année scolaire en un bulletin général cumulatif.',
    'rc.aiAnalysis': 'Analyse IA',
    'rc.aiGenerate': 'Générer l\u2019analyse',
    'rc.aiRegenerate': 'Régénérer',
    'rc.aiGenerating': 'Analyse de la classe… cela peut prendre jusqu\u2019à une minute.',
    'rc.aiNone': 'Aucune analyse pour le moment. Générez-en une ci-dessous.',
    'rc.aiHint': 'Analyse par IA de tout le bulletin de la classe.',
    'rc.aiCharts': 'Aperçus visuels',
    'rc.aiSummary': 'Analyse détaillée',
    'rc.exportPdf': 'Exporter en PDF',
    'rc.pdfExporting': 'Exportation…',
    'rc.pdfDone': 'PDF exporté',
    'rc.pdfFailed': "Échec de l'exportation du PDF",
    'rc.aiDone': 'Analyse prête',
    'rc.aiFailed': 'Échec de l\u2019analyse IA',
    'common.close': 'Fermer',
    'portal.studentTitle': 'Ma scolarité',
    'portal.parentTitle': 'Mes enfants',
    'portal.teacherTitle': 'Mes classes',
    'portal.selectExam': 'Sélectionner un examen',
    'portal.viewReport': 'Voir le bulletin',
    'portal.noProfile': 'Aucun profil n\u2019est encore associé à votre compte. Veuillez contacter l\u2019administration.',
    'portal.lessons': 'Leçons',
    'portal.lessonsEmpty': 'Aucune leçon n\u2019a encore été partagée avec votre classe.',
    'portal.openLesson': 'Ouvrir la leçon',
    'portal.myTimetable': 'Mon emploi du temps',
    'portal.noTimetable': 'Pas encore d\u2019emploi du temps',
    'portal.noTimetableHint': 'Votre emploi du temps pour cette année scolaire n\u2019a pas encore été publié.',
    'role.super_admin': 'Super Administrateur',
    'role.admin': 'Admin',
    'role.administration': 'Administration',
    'role.direction': 'Direction',
    'role.coordinator': 'Coordinateur',
    'role.accountant': 'Comptable',
    'role.receptionist': 'Réceptionniste',
    'role.librarian': 'Bibliothécaire',
    'role.driver': 'Chauffeur',
    'role.service': 'Service',
    'role.teacher': 'Enseignant',
    'role.student': 'Élève',
    'role.parent': 'Parent',
    'role.viewer': 'Lecteur',
    'role.cashier': 'Caissier',
    'people.loginAccount': 'Compte de connexion',
    'people.role': 'Rôle',
    'people.password': 'Mot de passe',
    'people.loginRequired': 'Un compte (e-mail, mot de passe et rôle) est obligatoire.',
  },
};
